// FIG ATT&CK (DESIGN_SPEC §11.4.6, §10.12, §12.13). Props: FigProps { ctx, no }. Renders its own journal cell (s4 side).
//   meta(ctx) → { id: "attack", label: "ATT&CK", count: techniques, empty: live, no verdict or no technique ids }
import { useMemo } from "react";
import { Empty, FigHead, figTitleId } from "@/components/ui";
import type { FigMeta, FigProps, ReportCtx } from "@/lib/derive/types";
import { reportVerdict } from "@/lib/derive/verdict";
import { attackTable } from "../derive/attack";

export function meta(ctx: ReportCtx): FigMeta {
  const v = ctx.mode === "live" ? null : reportVerdict(ctx.stream, ctx.behaviorReport);
  const n = v ? attackTable(v.tags).techniqueCount : 0;
  return { id: "attack", label: "ATT&CK", count: n, empty: n === 0 };
}

export default function AttackFig({ ctx, no }: FigProps) {
  const v = ctx.mode === "live" ? null : reportVerdict(ctx.stream, ctx.behaviorReport);
  const tags = v?.tags;
  const table = useMemo(() => attackTable(tags ?? []), [tags]);
  const k = table.tactics.length;
  const n = table.techniqueCount;

  return (
    <section className="cell s4 side fig" aria-labelledby={figTitleId(no)}>
      <FigHead no={no} label="ATT&CK" count={`v19 · ${n} ${n === 1 ? "technique" : "techniques"}`} />
      {k === 0 ? (
        <Empty inline>No technique ids</Empty>
      ) : (
        <div className="fig-body attack">
          {table.tactics.map((tac) => (
            <div key={tac.id} className="tactic">
              <div className="tactic-h">
                <span>{tac.name}</span>
                <span translate="no">{tac.id}</span>
              </div>
              {tac.techs.map((x) => (
                <div key={x.id} className="tech">
                  <a href={x.href} target="_blank" rel="noopener noreferrer" translate="no" title={x.dagger ? `${x.id}: verify against ATT&CK v19` : undefined}>
                    {x.dagger ? `${x.id}†` : x.id}
                  </a>
                  <span>
                    {x.name || "Not in the v19 table"}
                    <small>{[x.rules.join(" · "), x.also.length ? `also ${x.also.join(", ")}` : ""].filter(Boolean).join(" · ")}</small>
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
